import { Routes } from '@angular/router';
import { EigentuemerSucheComponent } from './eigentuemer-suche/eigentuemer-suche.component';
import { ErweiterungConfigResponse, PermissionResponse } from '../../core/base-api';
import { canActivateAuthorization } from '../../security/authorization.guard';
import PermissionsEnum = PermissionResponse.PermissionsEnum;
import ActiveErweiterungenEnum = ErweiterungConfigResponse.ActiveErweiterungenEnum;

export const ErweitertesSuchregisterRoutes: Routes = [
  {
    path: 'erweitertes-suchregister',
    canActivate: [canActivateAuthorization],
    data: {
      permissions: [PermissionsEnum.LOGIN],
      erweiterung: [ActiveErweiterungenEnum.ERWEITERTES_SUCHREGISTER]
    },
    loadChildren: () => routes
  }
];

const routes: Routes = [
  {
    path: '**',
    redirectTo: 'suche'
  },
  {
    path: 'suche',
    data: {
      permissions: [PermissionsEnum.LOGIN],
      erweiterung: [ActiveErweiterungenEnum.ERWEITERTES_SUCHREGISTER]
    },
    component: EigentuemerSucheComponent
  }
];
